import Vue from "vue";

export const receiveMessage = ({ commit, rootState }, event) => {
  if (
    !rootState.opener.shopDomain ||
    event.origin !== rootState.opener.shopDomain
  ) {
    return;
  }

  if (event.data && event.data.hasOwnProperty("event")) {
    switch (event.data.event) {
      case "pageParams":
        if (!event.data.message.products) {
          event.data.message.products = {};
        }
        rootState.pageParams = event.data.message;
        commit("ui/SET_LOADED_PAGE_PARAMS", true, { root: true });
        break;
    }
  }
};

export const close = ({ dispatch }) => {
  dispatch(
    "opener/postMessage",
    { event: "unload", message: {} },
    { root: true }
  );
  setTimeout(function() {
    window.close();
  }, 200); // TODO: Test if 100 also works (Especially Safari mobile)
};

export const addCartLog = ({ rootState }) => {
  let payload = {};
  let matches = [];
  if (Array.isArray(rootState.users.match)) {
    for (let i = 0; i < rootState.users.match.length; i++) {
      let item = rootState.users.match[i];
      if (item.SIZE) {
        payload.user = item.USER;
        payload.retailer = item.RETAILERID;
        payload.product = item.PRODUCTID;
        payload.size = item.SIZE;
        matches.push(payload);
      }
    }
    Vue.$axios.post("cart_logs", matches);
  }
};
